import { addMessages } from '@hana/i18n';

// Khoá chuỗi opst.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'opst.1': "Trả lại",
  'opst.2': "Duyệt",
  'opst.3': "Nhắc chứng từ",
  'opst.4': "Lộ trình",
  'opst.5': "Điểm chen",
  'opst.6': "Các khoản chi",
  'opst.7': "Thiếu ảnh",
  'opst.8': "Lương chặng",
  'opst.9': "Chuyển BIL",
  'opst.10': "Yêu cầu xuất lại tên khách",
  'opst.11': "VETC đối chiếu sao kê",
  'opst.12': "Không phát sinh",
  'opst.13': "Đưa lên Job",
  'opst.14': "Lịch sử",
  'opst.15': "Mở lệnh vận tải",
});
addMessages('en', {
  'opst.1': "Return",
  'opst.2': "Approve",
  'opst.3': "Remind documents",
  'opst.4': "Route",
  'opst.5': "Extra stop",
  'opst.6': "Expenses",
  'opst.7': "Missing photo",
  'opst.8': "Leg pay",
  'opst.9': "Move to BIL",
  'opst.10': "Request re-issue under customer name",
  'opst.11': "VETC statement reconciliation",
  'opst.12': "None incurred",
  'opst.13': "Push to Job",
  'opst.14': "History",
  'opst.15': "Open transport order",
});
